import SectionMessage, { SectionMessageAction } from '@atlaskit/section-message';
import TokenExplorer from "../../../../../../packages/design-system/tokens/docs/token-explorer";
import * as React from 'react';
export default {
  SectionMessage,
  SectionMessageAction,
  TokenExplorer,
  React
};